export default {"card":"_8g4Kv","content":"Rbk32","front":"WeqMu","back":"FYasf"};